import { defineMessages } from 'react-intl-next';

export const notionDataFormatOptionsMessages = defineMessages({
	mentions: {
		id: 'import-feedback.data-format-options.notion.mentions',
		defaultMessage: '@mentions',
		description:
			'A single dropdown option indicating the @mentions feature in Notion, as part of a feedback survey',
	},
	audioEmbeddedLink: {
		id: 'import-feedback.data-format-options.notion.audio-embedded-link',
		defaultMessage: 'Audio (embedded link)',
		description:
			'A single dropdown option indicating the audio (embedded link) feature in Notion, as part of a feedback survey',
	},
	attachments: {
		id: 'import-feedback.data-format-options.notion.attachments',
		defaultMessage: 'Attachments',
		description:
			'A single dropdown option indicating the attachments feature in Notion, as part of a feedback survey',
	},
	blockEquation: {
		id: 'import-feedback.data-format-options.notion.block-equation',
		defaultMessage: 'Block equation',
		description:
			'A single dropdown option indicating the block equation feature in Notion, as part of a feedback survey',
	},
	breadcrumb: {
		id: 'import-feedback.data-format-options.notion.breadcrumb',
		defaultMessage: 'Breadcrumb',
		description:
			'A single dropdown option indicating the breadcrumb feature in Notion, as part of a feedback survey',
	},
	bulletedLists: {
		id: 'import-feedback.data-format-options.notion.bulleted-lists',
		defaultMessage: 'Bullet lists',
		description:
			'A single dropdown option indicating the bullet lists feature in Notion, as part of a feedback survey',
	},
	button: {
		id: 'import-feedback.data-format-options.notion.button',
		defaultMessage: 'Button',
		description:
			'A single dropdown option indicating the button feature in Notion, as part of a feedback survey',
	},
	callout: {
		id: 'import-feedback.data-format-options.notion.callout',
		defaultMessage: 'Callout',
		description:
			'A single dropdown option indicating the callout feature in Notion, as part of a feedback survey',
	},
	codeBlock: {
		id: 'import-feedback.data-format-options.notion.code-block',
		defaultMessage: 'Code block',
		description:
			'A single dropdown option indicating the code block feature in Notion, as part of a feedback survey',
	},
	codeMermaid: {
		id: 'import-feedback.data-format-options.notion.code-mermaid',
		defaultMessage: 'Code - Mermaid (diagram)',
		description:
			'A single dropdown option indicating the code - mermaid (diagram) feature in Notion, as part of a feedback survey',
	},
	twoColumns: {
		id: 'import-feedback.data-format-options.notion.two-columns',
		defaultMessage: '2 columns',
		description:
			'A single dropdown option indicating the 2 columns feature in Notion, as part of a feedback survey',
	},
	customizedText: {
		id: 'import-feedback.data-format-options.notion.customized-text',
		defaultMessage: 'Customized text',
		description:
			'A single dropdown option indicating the customized text feature in Notion, as part of a feedback survey',
	},
	databaseChildPageProperties: {
		id: 'import-feedback.data-format-options.notion.database-child-page-properties',
		defaultMessage: 'Database child page properties',
		description:
			'A single dropdown option indicating the database child page properties feature in Notion, as part of a feedback survey',
	},
	dates: {
		id: 'import-feedback.data-format-options.notion.dates',
		defaultMessage: 'Dates',
		description:
			'A single dropdown option indicating the dates feature in Notion, as part of a feedback survey',
	},
	dividers: {
		id: 'import-feedback.data-format-options.notion.dividers',
		defaultMessage: 'Dividers',
		description:
			'A single dropdown option indicating the dividers feature in Notion, as part of a feedback survey',
	},
	embed: {
		id: 'import-feedback.data-format-options.notion.embed',
		defaultMessage: 'Embed (e.g. Figma)',
		description:
			'A single dropdown option indicating the embed (e.g. Figma) feature in Notion, as part of a feedback survey',
	},
	emojis: {
		id: 'import-feedback.data-format-options.notion.emojis',
		defaultMessage: 'Emojis',
		description:
			'A single dropdown option indicating the emojis feature in Notion, as part of a feedback survey',
	},
	headerImages: {
		id: 'import-feedback.data-format-options.notion.header-images',
		defaultMessage: 'Header images',
		description:
			'A single dropdown option indicating the header images feature in Notion, as part of a feedback survey',
	},
	headings: {
		id: 'import-feedback.data-format-options.notion.headings',
		defaultMessage: 'Headings',
		description:
			'A single dropdown option indicating the headings feature in Notion, as part of a feedback survey',
	},
	images: {
		id: 'import-feedback.data-format-options.notion.images',
		defaultMessage: 'Images',
		description:
			'A single dropdown option indicating the images feature in Notion, as part of a feedback survey',
	},
	inlineEquation: {
		id: 'import-feedback.data-format-options.notion.inline-equation',
		defaultMessage: 'Inline equation',
		description:
			'A single dropdown option indicating the inline equation feature in Notion, as part of a feedback survey',
	},
	linkToPage: {
		id: 'import-feedback.data-format-options.notion.link-to-page',
		defaultMessage: 'Link to page',
		description:
			'A single dropdown option indicating the link to page feature in Notion, as part of a feedback survey',
	},
	numberedLists: {
		id: 'import-feedback.data-format-options.notion.numbered-lists',
		defaultMessage: 'Numbered lists',
		description:
			'A single dropdown option indicating the numbered lists feature in Notion, as part of a feedback survey',
	},
	pageComments: {
		id: 'import-feedback.data-format-options.notion.page-comments',
		defaultMessage: 'Page comments',
		description:
			'A single dropdown option indicating the page comments feature in Notion, as part of a feedback survey',
	},
	pageEmojis: {
		id: 'import-feedback.data-format-options.notion.page-emojis',
		defaultMessage: 'Page emojis',
		description:
			'A single dropdown option indicating the page emojis feature in Notion, as part of a feedback survey',
	},
	quotes: {
		id: 'import-feedback.data-format-options.notion.quotes',
		defaultMessage: 'Quotes',
		description:
			'A single dropdown option indicating the quotes feature in Notion, as part of a feedback survey',
	},
	reminder: {
		id: 'import-feedback.data-format-options.notion.reminder',
		defaultMessage: 'Reminder',
		description:
			'A single dropdown option indicating the reminder feature in Notion, as part of a feedback survey',
	},
	staticTables: {
		id: 'import-feedback.data-format-options.notion.static-tables',
		defaultMessage: 'Static tables',
		description:
			'A single dropdown option indicating the static tables feature in Notion, as part of a feedback survey',
	},
	syncedBlock: {
		id: 'import-feedback.data-format-options.notion.synced-block',
		defaultMessage: 'Synced block',
		description:
			'A single dropdown option indicating the synced block feature in Notion, as part of a feedback survey',
	},
	tableCustomization: {
		id: 'import-feedback.data-format-options.notion.table-customization',
		defaultMessage: 'Table customization',
		description:
			'A single dropdown option indicating the table customization feature in Notion, as part of a feedback survey',
	},
	tableData: {
		id: 'import-feedback.data-format-options.notion.table-data',
		defaultMessage: 'Table data',
		description:
			'A single dropdown option indicating the table data feature in Notion, as part of a feedback survey',
	},
	tableOfContents: {
		id: 'import-feedback.data-format-options.notion.table-of-contents',
		defaultMessage: 'Table of contents',
		description:
			'A single dropdown option indicating the table of contents feature in Notion, as part of a feedback survey',
	},
	todoList: {
		id: 'import-feedback.data-format-options.notion.todo-list',
		defaultMessage: 'To-Do list',
		description:
			'A single dropdown option indicating the to-do list feature in Notion, as part of a feedback survey',
	},
	toggleHeading: {
		id: 'import-feedback.data-format-options.notion.toggle-heading',
		defaultMessage: 'Toggle heading',
		description:
			'A single dropdown option indicating the toggle heading feature in Notion, as part of a feedback survey',
	},
	toggleList: {
		id: 'import-feedback.data-format-options.notion.toggle-list',
		defaultMessage: 'Toggle list',
		description:
			'A single dropdown option indicating the toggle list feature in Notion, as part of a feedback survey',
	},
	videoEmbeddedLink: {
		id: 'import-feedback.data-format-options.notion.video-embedded-link',
		defaultMessage: 'Video (embedded link)',
		description:
			'A single dropdown option indicating the video (embedded link) feature in Notion, as part of a feedback survey',
	},
	webBookmark: {
		id: 'import-feedback.data-format-options.notion.web-bookmark',
		defaultMessage: 'Web bookmark',
		description:
			'A single dropdown option indicating the web bookmark feature in Notion, as part of a feedback survey',
	},
	other: {
		id: 'import-feedback.data-format-options.notion.other',
		defaultMessage: 'Other',
		description:
			'A single dropdown option indicating the other feature in Notion, as part of a feedback survey',
	},
});
